
















































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import HeadBack from '@/views/competition/components/HeadBack.vue'
import { getTitleList,empowermentCompetition,getCompetitionEmployee,disempowermentCompetition } from '@/api/competition'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'

@Component({
  name: 'empowerment',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private title = '权限管理';
  private page: number = 1
  private pageSize: number = 10
  private checkList: string[] = []
  private tableData = []
  private competitionEmployeeData = []
  private id = ''
  private userId = ''
  private titleId = ''
  private status = ''
  private liveStreamingStatus = ''
  private gift = ''
  private hots = ''
  private votes = ''
  private isSearch: boolean = false
  private classData: any = {
    title: '修改免费投票次数和增加的热度',
    dialogVisible: false,
    categoryId: '',
    votes: '',
    hots: ''
  }



  created() {
    this.userId = this.$route.query.id
    this.init()
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  get userName() {
    return UserModule.username
  }

  private async init(isSearch?: boolean) {
    this.isSearch = isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      content: this.input ? this.input : undefined,
      type: 0,
    }
    await getTitleList(params)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = res.data.data.total
        }
        // if (!res.data.data.records.length && type === 'search') {
        //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
        // }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
      await getCompetitionEmployee({id: this.$route.query.id})
      .then((res: any) => {
        this.competitionEmployeeData = res.data.data
        // 如果competitionEmployeeData的数据不为空，比较competitionEmployeeData数组的titleId是否与tableData数组的id相同，如果相同，
        // 将tableData的type为1，否则为0
        if (this.competitionEmployeeData.length > 0) {
          this.tableData.forEach((item: any) => {
            this.competitionEmployeeData.forEach((item1: any) => {
              if (item.id === item1.titleId) {
                item.type = 1;
              }
            })
          })
        }

      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 添加
  private addEmployeeHandle(st: string, username: string) {
    if (st === 'add') {
      this.$router.push({ path: '/competition/add' })
    } else {
      if (username === 'admin') {
        return
      }
      this.$router.push({ path: '/competition/add', query: { id: st } })
    }
  }



  // 赋权
  private empowermentHandle(type: string, id: any) {
    const params = {
      ids: id,
      id: this.userId
    }
    if (type === 1) {
      this.$confirm('确认去权该赛事, 是否继续?', '确定去权', {
      confirmButtonText: '去权',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      disempowermentCompetition(params)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
          this.$message.success('去权成功！')
          this.init()
        } else {
          this.$message.error(res.data.msg)
        }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
    } else {
      this.$confirm('确认赋权该赛事, 是否继续?', '确定赋权', {
      confirmButtonText: '赋权',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      empowermentCompetition(params)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success('赋权成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
    }

  }


  // 全部操作
  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    val.forEach((n: any) => {
      checkArr.push(n.id)
    })
    this.checkList = checkArr
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
}
